// extracted by mini-css-extract-plugin
export default {"loadingMarker":"loadingMarker_loadingMarker__lKpYx"};